const actions = {
    SET_IS_AUTHENTICATED: "SET_IS_AUTHENTICATED",
    SET_USER_ROLE: "SET_USER_ROLE",
    SET_USER_DATA: "SET_USER_DATA",
    SET_AUTH_STATE: "SET_AUTH_STATE",
};

export default actions;
